import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { AuditEntity, AuditLogWithUser, AuditOperation } from '@extTypes/auditLog/types';
import { getAuditEntriesWithUsers } from '@/api/customily/auditLog';
import { DateFormat, formatDate } from '@/utils/dates';
import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuditLog',
  props: {
    value: { type: Boolean },
    entityType: null,
    entityId: null,
    entityCreatedDate: null,
    displayName: null
  },
  emits: ["input", "close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    entityType: AuditEntity;
    entityId?: string | number;
    entityCreatedDate?: Date | string;
    displayName?: string;
};



const loading = ref(true);
const auditEntries = ref<AuditLogWithUser[]>([]);
const { state } = useStore();



const closeModal = () => {
    emit('close');
};

const isOpen = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emit('input', value);
    }
});

watch(
    () => props.entityId,
    () => {
        if (props.entityId) {
            getAuditEntriesWithUsers(props.entityType, `${props.entityId}`)
                .then(async (data) => {
                    if (!data.some((e) => e.operation == 'C') && props) {
                        data.unshift({
                            entity: props.entityType,
                            entityId: `${props.entityId}`,
                            operation: AuditOperation.CREATE,
                            performedByUserId: state.user?.customilyUser.Id!,
                            date: new Date(props.entityCreatedDate!),
                            impersonatedUserId: null,
                            action: 'null',
                            details: null,
                            user: {
                                Id: 0,
                                Name: state.user?.customilyUser.Name ?? '',
                                Username: state.user?.customilyUser.Username ?? ''
                            }
                        });
                    }

                    auditEntries.value = data.reverse();

                    loading.value = false;
                })
                .catch((error) => {
                    loading.value = false;
                });
        }
    },
    { immediate: true }
);

const parseOperation = (operation: AuditOperation): string => {
    switch (operation) {
        case AuditOperation.CREATE:
            return 'Created';
        case AuditOperation.RESTORE:
            return 'Restored';
        case AuditOperation.UPDATE:
            return 'Updated';
        case AuditOperation.DELETE:
            return 'Deleted';
        default:
            return 'Unknown';
    }
};

const parseEntity = (entity: AuditEntity): string => {
    switch (entity) {
        case AuditEntity.LIBRARY:
            return 'Library';
        case AuditEntity.OPTION_SET:
            return 'Option Set';
        case AuditEntity.PRODUCT:
            return 'Product';
        case AuditEntity.TEMPLATE:
            return 'Template';
        default:
            return 'Unknown';
    }
};

const getTitle = (): string => {
    return `${parseEntity(props.entityType)} history`;
};

const getFormattedDate = (date: Date): string => {
    return formatDate(date, DateFormat.MMMddYYYYTime);
};

return { __sfc: true,props, loading, auditEntries, state, emit, closeModal, isOpen, parseOperation, parseEntity, getTitle, getFormattedDate }
}

})